/**
 * RefreshButton
 *
 * Button zum manuellen Prüfen des Status vom Server.
 * Zeigt Spinner während der Abfrage.
 */

import { useState } from 'preact/hooks';
import { RefreshCw } from 'lucide-preact';
import { checkRemoteStatus } from '../../stores/timesheet.store';
import styles from './RefreshButton.module.css';

export function RefreshButton() {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    if (isRefreshing) return;

    setIsRefreshing(true);
    try {
      await checkRemoteStatus();
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleRefresh}
      disabled={isRefreshing}
      className={styles.button}
      title="Status vom Server prüfen"
      aria-label="Status vom Server prüfen"
    >
      <RefreshCw size={18} className={isRefreshing ? styles.spinning : ''} />
    </button>
  );
}
